import { HttpClient, HttpResponse } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {Attendee} from '../shared/Attendee';
import {TimetableEntry} from '../shared/TimetableEntry';
import {MiniBookAdminService} from './mini-book-admin.service';

export class TimetableEntryService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getTimetableEntries(): Observable<TimetableEntry[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/timetableEntries`).pipe(
      map<any[], TimetableEntry[]>(data => data.map(value => TimetableEntry.createFromJson(value)))
    );
  }

  getTimetableEntry(id: number): Observable<TimetableEntry> {
    return this.http.get<any>(`${this.adminService.tenant}/timetableEntries/${id}`).pipe(
      map<any, TimetableEntry>(data => TimetableEntry.createFromJson(data))
    );
  }

  createTimetableEntry(timetableEntry: TimetableEntry): Observable<TimetableEntry> {
    return this.http.post<any>(`${this.adminService.tenant}/timetableEntries`, timetableEntry.toJson()).pipe(
      map<any, TimetableEntry>(data => TimetableEntry.createFromJson(data))
    );
  }

  updateTimetableEntry(id: number, timetableEntry: TimetableEntry): Observable<TimetableEntry> {
    return this.http.put<any>(`${this.adminService.tenant}/timetableEntries/${id}`, timetableEntry.toJson()).pipe(
      map<any, TimetableEntry>(data => TimetableEntry.createFromJson(data))
    );
  }

  deleteTimetableEntry(id: number): Observable<void> {
    return this.http.delete<void>(`${this.adminService.tenant}/timetableEntries/${id}`);
  }

  getAttendees(id: number): Observable<Attendee[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/timetableEntries/${id}/attendees`).pipe(
      map<any[], Attendee[]>(data => data.map(value => Attendee.createFromJson(value)))
    );
  }

  addAttendee(timetableEntryId: number, attendee: Attendee): Observable<TimetableEntry> {
    return this.http.put<any>(`${this.adminService.tenant}/timetableEntries/${timetableEntryId}/attendees/${attendee.id}`, null).pipe(
      map<any, TimetableEntry>(data => TimetableEntry.createFromJson(data))
    );
  }

  removeAttendee(timetableEntryId: number, attendee: Attendee): Observable<TimetableEntry> {
    return this.http.delete<any>(`${this.adminService.tenant}/timetableEntries/${timetableEntryId}/attendees/${attendee.id}`).pipe(
      map<any, TimetableEntry>(data => TimetableEntry.createFromJson(data))
    );
  }

  deleteAllUsers(id: number) {
    return this.http.delete<void>(`${this.adminService.tenant}/timetableEntries/${id}/attendees/`);
  }

  downloadAttendeeList(id:number): Observable<HttpResponse<Blob>>{
    return this.http.get(`${this.adminService.tenant}/timetableEntries/${id}/attendees/export/csv`, {observe: 'response', responseType: 'blob'});
  }
}
